import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { Home, Info, FileText, ShieldCheck, AlertCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import CalculatorPage from "./pages/CalculatorPage";
import InfoPage from "./pages/InfoPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import DisclaimerModal from "./components/DisclaimerModal";
import Navigation from "./components/Navigation";

export default function App() {
  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(false);
  const [result, setResult] = useState("");
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Laden des Disclaimer-Status
    const accepted = localStorage.getItem("acceptedDisclaimer");
    if (accepted === "true") setAcceptedDisclaimer(true);
    
    // Laden des letzten Berechnungsergebnisses, falls vorhanden
    const savedResult = localStorage.getItem("calculationResult");
    if (savedResult) setResult(savedResult);
    
    // Automatischer Dark/Light Mode
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
      document.documentElement.classList.add('dark');
    }

    // Listener für Änderungen der Systempräferenz
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleDarkModeChange = (e) => {
      const newTheme = e.matches ? 'dark' : 'light';
      setTheme(newTheme);
      
      if (newTheme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };
    
    darkModeMediaQuery.addEventListener('change', handleDarkModeChange);
    
    return () => {
      darkModeMediaQuery.removeEventListener('change', handleDarkModeChange);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem("acceptedDisclaimer", "true");
    setAcceptedDisclaimer(true);
  };
  
  // Funktion um Ergebnis in localStorage zu speichern
  const handleSetResult = (newResult) => {
    setResult(newResult);
    localStorage.setItem("calculationResult", newResult);
  };

  return (
    <Router>
      <div className={theme === 'dark' ? 'dark' : ''}>
        <AnimatePresence>
          {!acceptedDisclaimer && <DisclaimerModal onAccept={handleAccept} />}
        </AnimatePresence>
        
        <Routes>
          <Route path="/" element={<CalculatorPage result={result} setResult={handleSetResult} />} />
          <Route path="/info" element={<InfoPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
        </Routes>
        
        <Navigation />
      </div>
    </Router>
  );
}